const ServicePlanPaymentFrequency = Object.freeze({
  MONTHLY: 1,
  ANNUAL: 2,
});

export default ServicePlanPaymentFrequency;
